export enum EAdminKycQueryKey {
  ADMIN_KYC_LIST = 'ADMIN_KYC_LIST',
  ADMIN_KYC_FINALIZE = 'ADMIN_KYC_FINALIZE',
  ADMIN_AGENT_KYC_LIST = 'ADMIN_AGENT_KYC_LIST',
  ADMIN_AGENT_KYC_FINALIZE = 'ADMIN_AGENT_KYC_FINALIZE',
}

import type {
  AdminListVideoKyCsParams,
  AdminFinalizeVideoKYCInput,
  AdminListVideoKYCsOutput,
  AdminFinalizeVideoKYCOutput,
  AdminListAgentKyCsParams,
  AdminListAgentKYCsOutput,
  AdminFinalizeAgentKYCInput,
  AdminFinalizeAgentKYCOutput,
} from '../api'

export type {
  AdminListVideoKyCsParams,
  AdminFinalizeVideoKYCInput,
  AdminListVideoKYCsOutput,
  AdminFinalizeVideoKYCOutput,
  AdminListAgentKyCsParams,
  AdminListAgentKYCsOutput,
  AdminFinalizeAgentKYCInput,
  AdminFinalizeAgentKYCOutput,
}
